import { createSelector } from 'reselect'
import config from 'constants/config'
import type { ChannelMarkupSource } from 'lib/channelMarkup/channelMarkupV2'

export const getChannelMarkup = (state: App.State) => config.ENABLE_CHANNEL_MARKUP ? state.marketing.channelMarkup : undefined

/**
 * The mode-tagged markup source to thread through the offer mappers. v2 selection has been
 * unwired: the client-init config that fed the v2 session round is no longer produced, so this
 * always returns the v1 `channelMarkup` source. A future source (the marketing router) will
 * reintroduce a v2 branch here; today it is always v1.
 *
 * Kept as a `createSelector` so reactive `useAppSelector` consumers keep a stable reference and
 * only recompute when the underlying v1 `channelMarkup` actually changes.
 */
export const getChannelMarkupSource = createSelector(
  (state: App.State) => getChannelMarkup(state),
  (channelMarkup): ChannelMarkupSource => ({ mode: 'v1', channelMarkup }),
)
